/**
 * How the application addresses somebody, in one place.
 *
 * Home and the personal pages both open on a greeting, and a second copy of this
 * would drift: one screen saying good afternoon at five while the other had moved
 * on to the evening is the sort of small wrongness that makes an application feel
 * like several applications.
 *
 * The clock is the reader's own, not the convention's. A greeting is about the
 * person holding the phone, and anyone in the hall shares the venue's hours
 * anyway; anyone who is not is better served by their own morning.
 */
export function greeting(now: Date): string {
  const hour = now.getHours();
  if (hour < 12) return "Good morning";
  if (hour < 17) return "Good afternoon";
  return "Good evening";
}

/**
 * The name to greet somebody by.
 *
 * First name only. "Good morning, Nathan" is how a colleague speaks; the full
 * name on the registration record is how a database does.
 */
export function firstName(name: string): string {
  return name.trim().split(/\s+/u)[0] || name;
}
